<template>
  <div>
    <div class="card-bind">
      <van-nav-bar title="卡余额充值" @click-left="onClickLeft" left-text="返回" left-arrow></van-nav-bar>
      <div class="page-content">
        <fieldset class="md-field" v-if="stockInfo.rechargeType==2" style="font-size: 14px;font-weight: normal">
          <div class="md-field-item-content">
            <label class="md-field-item-title">当前余额</label>
            <div class="md-field-item-control" style="font-weight: bolder;font-size: .42rem;color: #3a8ee6;">
              {{$route.query.remainUsage}} 元
            </div>
          </div>
        </fieldset>
        <fieldset class="md-field">
          <div class="md-field-content">
            <van-row v-if="packageList.length>0">
              <van-col span="11" :offset="key % 2 == 0 ? 0 : 2" v-for="(item,key) in packageList" :key="item.id"
                       @click="checkPackage(item)">
                <div class="package-item" :class="packageID==item.id?'active':''">
                  <div class="line-1">
                    <div class="title" style="text-align: center;">{{item.balance}} <span style="font-size: .30rem;color: #666;">元</span></div>
                  </div>
                </div>
              </van-col>
              <van-col span="24">
                <div style="color: #999988;font-size: .3rem;font-weight: bolder;text-align: left;">计费方式:
                  <span style="font-weight: bolder;font-size: .32rem;color: #ff2e2e">{{stockInfo.singlePrice}}元/每G</span>
                  ，用完为止</div>
              </van-col>
            </van-row>
            <div v-else>
              <div>
                <van-icon name="coupon-o" color="#969696" size="72"/>
              </div>
              <div style="font-size: 14px;color: #969696">没有可以金额</div>
            </div>
          </div>
        </fieldset>
        <fieldset class="md-field" v-if="packageID>0" style="font-size: 14px;font-weight: normal">
          <div class="md-field-item-content">
            <label class="md-field-item-title">支付金额</label>
            <div class="md-field-item-control" style=" ">
              <span style="color: #cf682c;font-size: .42rem">{{one.price}}</span> 元
            </div>
          </div>
        </fieldset>
        <fieldset class="md-field">
          <div class="md-field-content">
            <div @click="createOrder" class="md-button primary active block"
                 :class="{'active':packageID>0,'inactive':packageID==0}">
              <div class="md-button-inner">
                <div class="md-button-content"><span>支付 &gt;&gt;&gt;</span></div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
    </div>
    <div class="warm-tips">
      <h5>温馨提示</h5>
      <ol>
        <li>计费方式:{{stockInfo.singlePrice}}元/每G，用完为止</li>
        <li>充值余额前请确认卡号是否正确</li>
        <li>余额使用后，不可退款</li>
      </ol>
    </div>
  </div>
</template>

<script>
export default {
  name: "recharge",
  data () {
    return {
      iccid: "",
      packageID: 0,
      packageList: [],
      one: {},
      stockInfo: {}
    }
  },
  methods: {
    queryPackageList () {
      this.$toast.loading()
      this.fetchData("/package/cardBalancePackage", {iccid: this.iccid}, (res) => {
        this.$toast.clear()
        if (res.code) {
          this.packageList = res.data
        } else {
          this.$toast.fail(res.msg)
          this.packageList = []
        }
      })
    },
    checkPackage (item) {
      this.packageID = item.id
      this.one = item
    },
    createOrder () {
      this.commitorder()
    },
    commitorder () {
      this.$toast.loading()
      this.fetchDataPost("/order/createYueOrder", {
        iccid: this.iccid,
        packageID: this.packageID,
      }, (res) => {
        this.$toast.clear()
        if (res.code) {
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest", res.data,
            (res) => {
              if (res.err_msg == "get_brand_wcpay_request:ok") {
                this.$toast.success("支付成功")
                this.$router.back()
              }
            }
          )
        } else {
          if (res.url) {
            this.$dialog.confirm({
              title: "提示",
              message: res.msg
            }).then(() => {
              // on confirm
              let query = {}
              if (res.data) {
                query = res.data
              }
              query.cardno = this.iccid
              this.$router.push({path: res.url, query: query})
            }).catch(() => {
              // on cancel
            })
          } else {
            if (res.msg.indexOf("appid") !== -1 && res.msg.indexOf("openid") !== -1) {
              this.$toast.fail("登录失效，请尝试重新进入查询")
              sessionStorage.clear()
            } else {
              this.$toast.fail(res.msg)
            }
          }
        }
      })
    },
    getStockInfo () {
      this.fetchData("/card/info", {iccid: this.iccid}, (res) => {
        this.stockInfo = res.data
        if (this.stockInfo.amount > 0) {
          this.type = 1
        }
      })
    }
  },
  created: function () {
    let query = this.$route.query
    this.iccid = query.iccid
    this.getStockInfo()
    this.queryPackageList()
  }
}
</script>
<style lang="scss" scoped>

  .md-field-item-content {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    min-height: 1rem;
    /*padding-top: .3rem;
    padding-bottom: .3rem;*/
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
  }
  .warm-tips{
    padding-left: 0;
    margin-left: .2rem;
    ol{
      padding-left: .32rem;
    }
  }

  .md-field-item-title {
    text-align: left;
    width: 1.6rem;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    font-size: .32rem;
  }

  .md-field-item-control {
    text-align: left;
    position: relative;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 0%;
    flex: 1 1 0%;
    color: #111a34;
    font-size: .32rem;
    font-weight: 500;
    padding: 0;
    margin: 0;
    line-height: 1.15;
    border: none;
    background: none;
    outline: none;
    border: 0;
  }

  .md-field-item-control a {
    margin: 0 .1rem;
    font-size: .26rem;
    color: #3a8ee6;
    white-space: nowrap;
  }

  .van-col {
    margin-bottom: .2rem;
  }

  .package-item {
    padding: .3rem .1rem;
    border: 1px solid #75b2f9;
    border-radius: 5px;

    .line-1 {
      font-size: .36rem;
      display: block;
      color: #75b2f9;
      text-align: center;

      .title {
      }

      .price {

      }
    }

    .desc {
      margin-top: .2rem;
      font-size: .26rem;
      text-align: left;
    }
  }

  .page-title {
    margin: .3rem 0 0 0;
    font-size: .3rem;
    height: .8rem;
    line-height: .8rem;
    border-radius: .2rem .2rem 0 0;
    border-bottom: 1px solid #fafafa;
    color: #888;
    text-align: center;
  }

  .package-item.active {
    background: -webkit-gradient(linear, right top, left top, from(#3c6bff), to(#75b2f9));
    background: linear-gradient(180deg, #3c6bff, #75b2f9);
    .line-1 {
      color: #fff;
    }
    span{
      color: #fff!important;
    }
  }

  .page-content {
    padding-bottom: .1rem;
    min-height: 6rem;
    border-radius: 0 0 .2rem .2rem;
    background: #fff;
  }

  .md-button {
    display: block;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.36rem;
    font-weight: 500;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
    text-align: center;
    box-sizing: border-box;
    -webkit-appearance: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    border-width: initial;
    border-style: none;
    border-color: initial;
    border-image: initial;
    border-radius: 0.04rem;
    outline: 0px;
    transition: all 0.3s ease 0s;
    overflow: visible;
  }

  .md-button {
    position: relative;
  }

  .md-button.primary {
    background: #2f86f6;
    color: #fff;
  }

  .md-button.block {
    width: 100%;
  }

  .md-button.inactive {
    opacity: .3;
  }

  .md-button-inner {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    word-wrap: break-word;
    white-space: nowrap;
  }

  .package-desc-item {
    padding: 0 .4rem;
  }

  .package-desc {
    font-size: .16rem;
    overflow: hidden;
    word-wrap: break-word;
    text-align: left;
  }

  .package-item {

  }
  .md-field {
    padding: .1rem .2rem;
    border: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/rechargeBalance.vue